// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"TypeOfIncidentPage_themeRoot__YhxZP"};